<template>
  <div class="role-tabs" role="tablist" aria-label="Account role">
    <component
      :is="leftTo ? RouterLink : 'button'"
      class="role-tab"
      :class="{ 'role-tab--active': activeRoleValue === 'user' }"
      :to="leftTo || undefined"
      type="button"
      role="tab"
      :aria-selected="activeRoleValue === 'user'"
      @click="emit('select', 'user')"
    >
      User
    </component>
    <component
      :is="rightTo ? RouterLink : 'button'"
      class="role-tab"
      :class="{ 'role-tab--active': activeRoleValue === 'vendor' }"
      :to="rightTo || undefined"
      type="button"
      role="tab"
      :aria-selected="activeRoleValue === 'vendor'"
      @click="emit('select', 'vendor')"
    >
      Vendor
    </component>
  </div>
</template>

<script setup>
/* eslint-env vue/setup-compiler-macros */
import { computed } from 'vue'
import { RouterLink } from 'vue-router'

const props = defineProps({
  activeRole: {
    type: String,
    default: 'user'
  },
  leftTo: {
    type: String,
    default: '/register?role=user'
  },
  rightTo: {
    type: String,
    default: '/vendor-signup?role=vendor'
  }
})

const emit = defineEmits(['select'])
const activeRoleValue = computed(() => (props.activeRole === 'vendor' ? 'vendor' : 'user'))
</script>

<style scoped>
.role-tabs {
  display: inline-grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
  width: 100%;
  padding: 6px;
  border: 1px solid #f2dcc8;
  border-radius: 999px;
  background: #fff8f1;
}

.role-tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #7b5d47;
  font-size: 0.95rem;
  font-weight: 600;
  text-decoration: none;
  transition: background-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
  cursor: pointer;
}

.role-tab:hover {
  color: #3a2a1f;
  text-decoration: none;
}

.role-tab--active {
  background: #ffffff;
  color: #3a2a1f;
  box-shadow: 0 8px 24px rgba(90, 64, 37, 0.12);
}
</style>
